module.exports = "<p>\r\n  rmenu works!\r\n  <span *ngIf=\"mostrar_menu=='true'\">mostrar menú</span>\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/rmenu/rmenu.component.html
// module id = ./src/app/components/rmenu/rmenu.component.html
// module chunks = main